import styled from "@emotion/styled";
import TemplateButton from '../../../components/templates/TemplateButton'
import TemplateHeader from '../../../components/templates/TemplateHeader'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'
import TemplateHero from '../../../components/templates/TemplateHero'
import { alpha } from '@mui/material/styles'

const Layout = styled.section``;

Layout.Container = styled.div`
  height: 100%;
  background: white !important;
`;

Layout.Content = styled(TemplateHero)`
  position: relative;
  height: calc(100vh);
  margin: 0 auto;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

Layout.Header = styled(TemplateHeader)`
  height: 80px;
  border-bottom-color: #c09e7c;
  border-bottom-width: 1px;
`;

Layout.Navigation = styled(TemplateNavigation)``

Layout.Nav = styled.ul`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;
Layout.NavItem = styled.li`
  list-style: none;
  height: 100%;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
`;

Layout.Bar = styled.div`
  background: #c09e7c;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  height: 48px;

  & > li {
    font-size: 12px;
    color: white;
  }
`;
Layout.HeaderInfo = styled.div`
  font-size: 15px;
`;

Layout.HeaderContent = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`;

Layout.Title = styled.h1`
  font-size: 22px;
  color: #000000;
  font-weight: bold;
`;

Layout.HeroTitle = styled.h2`
  font-size: 64px;
  font-weight: bold;
`;

Layout.HeroSubtitle = styled.h3`
  font-size: 28px;
  text-transform: uppercase;
`;

Layout.HeroDescription = styled.p`
  font-size: 16px;
  padding-bottom: 64px;
  border-bottom-color: ${({ theme }) => theme.palette.secondary.main};
  border-bottom-width: 2px;
`;

Layout.Menu = styled.div`
  display: flex;
  align-items: center;
  fill: white;
  color: white;
  gap: 32px;
`;

Layout.Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

Layout.Card = styled.div`
  width: 482px;
  padding: 32px;
  z-index: 2;
  margin-top: 48px;
  margin-left: 164px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ theme }) => alpha(theme.palette.text.secondary, 0.8)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

Layout.CTA = styled(TemplateButton)`
  font-size: 20px;
  width: 200px;
  margin-top: 1em;
  text-align: left; 
`;

export default Layout;
